import "./memberlist.css";
import * as React from "react";
import Tooltip from "@mui/material/Tooltip";
import Table from "@mui/material/Table";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CssBaseline from "@mui/material/CssBaseline";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Drawer from "@mui/material/Drawer";
import { ButtonGroup } from "@mui/material";
import DateFilter from "./DateFilter.jsx";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Header from "../Includes/Header";
import { useTheme as useAppTheme } from "../../contexts/ThemeContext";
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TableRow from "@mui/material/TableRow";
import dayjs from "dayjs";

// The member-details single-fetch endpoint returns dob/wedding_date as
// "DD-MM-YYYY" while the member-list endpoint returns them as ISO
// "YYYY-MM-DD" — plain dayjs(string) mis-parses the former, leaving the
// date picker blank when editing from the Member Details page.
const parseFlexibleDate = (value) => {
  if (!value) return null;
  if (typeof value === "string") {
    const dmY = value.match(/^(\d{2})-(\d{2})-(\d{4})$/);
    if (dmY) {
      const [, d, m, y] = dmY;
      return dayjs(`${y}-${m}-${d}`);
    }
  }
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed : null;
};
import { useState } from "react";
import { useEffect, useRef } from "react";
import {
  Card,
  Button,
  Grid,
  TextField,
  FormControl,
  OutlinedInput,
  InputLabel,
  Select,
  InputAdornment,
  MenuItem,
  FormHelperText,
  Paper,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import FlipCameraAndroidIcon from "@mui/icons-material/FlipCameraAndroid";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";

import {
  createNewMember,
  updateMember,
  AutoMembershipNumber,
  PackageDropdown,
  PackageDropdownvalue,
} from "../Apihelper/MemberApiHelpr";
import Menu from "@mui/material/Menu";import {
  PackageadmissionDropdown,
  PackageAdmissionDropdownvalue,
} from "../Apihelper/AdmissionValueApi.js";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import Autocomplete from "@mui/material/Autocomplete";
import useMediaQuery from "@mui/material/useMediaQuery";

import CircularProgress from "@mui/material/CircularProgress";
import json2mq from "json2mq";

import { useNavigate, useLocation } from "react-router-dom";
import AppToast from '../../components/Toast/AppToast';
import { generateCardNumber } from '../../utils/generateCardNumber';

const useStyles = styled((theme) => ({
  tableContainer: {
    maxWidth: 600,
    margin: "0 auto",
  },
  table: {
    display: "none", // Hide the table on all screens
    [theme.breakpoints.down("sm")]: {
      display: "table", // Show the table on small screens only (mobile view)
    },
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      display: "none", // Hide the card container on small screens (mobile view)
    },
  },
  card: {
    width: "100%",
    margin: "8px",
    padding: "16px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "300px", // Adjust the card width as needed
    },
  },
}));
const drawerWidth = 292;

function MemberList(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const { colors: appColors } = useAppTheme();
  const editMode = location.state?.editMode === true;
  const memberId = location.state?.memberId;
  const incomingMemberData = location.state?.memberData;

  const { window1 } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [openToast, setOpenToast] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // Default to 'success'
  const [Dropdowndata, setDropdowndata] = useState([]); // Default to 'success'
  const [packageamount, setpackageamount] = useState(""); // Default to 'success'
  const [Dropdownadmissiondata, setDropdownadmissiondata] = useState([]); // Default to 'success'
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const handleConfirmDialogOpen = () => {
    setOpenConfirmDialog(true);
  };
  
  const handleConfirmDialogClose = () => {
    setOpenConfirmDialog(false);
  };
  const triggerSave = () => {
    handleConfirmDialogOpen();
  };
  const handleConfirmSave = async () => {
    handleConfirmDialogClose(); // Close dialog
    await handleSave(); // Call the save function
  };
  
  const dateRef = useRef();
  React.useEffect(() => {
    const storedData = localStorage.getItem("userdata");
    if (!storedData) {
      // User is not logged in, no need to redirect
      navigate("/");
    }
  }, []);

  const [FormData, setFormData] = useState({
    selectedFile: null,
    membership_number: "",
    photo: "",
    phone: "",
    name: "",
    alter_phone: "",
    address: "",
    email: "",
    dob: null,
    wedding_date: null,
    occupation: "",
    batchnumber:"",
    height: "",
    weight: "",
    sex: "",
    package: "",
    packagename: "",

    packagevalue: "",
    totalpaybleamount: "",
    discount: "",
    payableamount: "",
    modeofpayment: "",
    payingamount: "",
    activationdate: dayjs(),
    dateofpayment:  dayjs(),
    identification_type: "",
    identification_id: "",
    membershipvalue:"",
    membership:"",
    membership_packagename:""

  });

  // Pre-populate form when navigated from edit button
  React.useEffect(() => {
    if (editMode && incomingMemberData) {
      setFormData((prev) => ({
        ...prev,
        membership_number: incomingMemberData.membership_number || prev.membership_number,
        name: incomingMemberData.name || "",
        phone: incomingMemberData.phone || "",
        email: incomingMemberData.email || "",
        alter_phone: incomingMemberData.alternate_phone || incomingMemberData.alter_phone || "",
        address: incomingMemberData.address || "",
        dob: parseFlexibleDate(incomingMemberData.dob),
        wedding_date: parseFlexibleDate(incomingMemberData.wedding_date),
        occupation: incomingMemberData.occupation || "",
        batchnumber: incomingMemberData.card_number || incomingMemberData.batchnumber || "",
        height: incomingMemberData.height || "",
        weight: incomingMemberData.weight || "",
        sex: incomingMemberData.sex || "",
        identification_type: incomingMemberData.identification_type || "",
        identification_id: incomingMemberData.identification_id || "",
        photo: incomingMemberData.image || incomingMemberData.photo || "",
      }));
    }
  }, [editMode]);

  const handleHeightChange = (e) => {
    let value = e.target.value;
  
    // Remove "feet" only if it's at the end of the string
    if (value.endsWith(" feet")) {
      value = value.slice(0, -5).trim(); // Remove " feet"
    }
  
    // Allow empty input for backspace and validate numbers
    if (/^\d*\.?\d*$/.test(value)) {
      setFormData({ ...FormData, height: value ? `${value} feet` : "" }); // Re-add "feet" for valid input
    }
  };
  
  
  
  const handleWeightChange = (e) => {
    let value = e.target.value.replace(" kg", "").trim(); // Remove existing unit
    // Check if the value is a valid number and within 2 or 3 characters
    if (/^\d{2,3}$/.test(value)) {
      value += " kg"; // Append unit if 2 or 3 digits
    }
    setFormData({ ...FormData, weight: value });
  };
  
  const mediaQueryVar = useMediaQuery(
    json2mq({
      minWidth: 600,
    })
  );

  const handleChangesex = (event) => {
    setSex(event.target.value);
  };

  const [submitted, setSubmitted] = useState(false);

  const drawer = (
    <div className="d-flex flex-column h-100">
      <Header />
    </div>
  );

  const ITEM_HEIGHT = 48;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [selectedFile, setSelectedFiles] = useState([]);

  // ── Webcam state ──────────────────────────────────────────────────────────
  const [webcamOpen, setWebcamOpen] = useState(false);
  const [webcamStream, setWebcamStream] = useState(null);
  const [facingMode, setFacingMode] = useState('user');
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  const openWebcam = async () => {
    setWebcamOpen(true);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode }, audio: false });
      setWebcamStream(stream);
      if (videoRef.current) videoRef.current.srcObject = stream;
    } catch (err) {
      alert('Could not access camera. Please allow camera permission.');
      setWebcamOpen(false);
    }
  };

  const closeWebcam = () => {
    if (webcamStream) { webcamStream.getTracks().forEach(t => t.stop()); setWebcamStream(null); }
    setWebcamOpen(false);
  };

  const capturePhoto = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    if (!video || !canvas) return;
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext('2d').drawImage(video, 0, 0);
    const dataUrl = canvas.toDataURL('image/jpeg', 0.92);
    // convert dataURL to File so backend upload still works
    canvas.toBlob(blob => {
      const file = new File([blob], 'webcam-photo.jpg', { type: 'image/jpeg' });
      setFormData(prev => ({ ...prev, selectedFile: file, photo: dataUrl }));
    }, 'image/jpeg', 0.92);
    closeWebcam();
  };

  const flipCamera = async () => {
    const next = facingMode === 'user' ? 'environment' : 'user';
    setFacingMode(next);
    if (webcamStream) { webcamStream.getTracks().forEach(t => t.stop()); }
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: next }, audio: false });
      setWebcamStream(stream);
      if (videoRef.current) videoRef.current.srcObject = stream;
    } catch {}
  };

  // attach stream when video element mounts after dialog opens
  useEffect(() => {
    if (webcamOpen && webcamStream && videoRef.current) {
      videoRef.current.srcObject = webcamStream;
    }
  }, [webcamOpen, webcamStream]);
  // ─────────────────────────────────────────────────────────────────────────

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const previewUrl = URL.createObjectURL(file);
    setFormData({ ...FormData, selectedFile: file, photo: previewUrl });
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const files = event.dataTransfer.files;
    setSelectedFiles([...selectedFile, ...files]);
    // Update FormData state to include selected files
    setFormData({
      ...FormData,
      selectedFile: [...FormData.selectedFile, ...files],
    });
  };

  const handleDrag = (event) => {
    event.preventDefault();
    // Your logic to handle dragging files here
    const files = event.dataTransfer.files;
    setSelectedFiles([...selectedFile, ...files]);
    // Update FormData state to include dragged files
    setFormData({
      ...FormData,
      selectedFile: [...FormData.selectedFile, ...files],
    });
  };
  // const handleSave = () => {
  //   console.log(FormData); // Log all data from FormData to the console
  //   // Here you can perform any additional actions, such as sending the data to an API
  // };
  const handleSnackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenToast(true);
  };
  const handleToastClose = () => {
    setOpenToast(false);
  };
  const [idselect, setidselect] = useState("");
  const handleSave = async () => {
    setSubmitted(true);
    console.log(FormData);

    const editRequiredFields = ["name", "phone", "address", "email", "dob", "sex"];
    const addRequiredFields = [
      "membership_number", "name", "phone", "address", "email", "dob",
      "height", "weight", "sex", "package", "packagevalue",
      "totalpaybleamount", "payableamount", "modeofpayment", "payingamount",
      "activationdate", "dateofpayment",
    ];
    const requiredFields = editMode ? editRequiredFields : addRequiredFields;
    const emptyFields = requiredFields.filter((field) => !FormData[field]);
    if (emptyFields.length > 0) {
      return;
    }

    const userData = localStorage.getItem("userdata");
    const userDataObj = JSON.parse(userData);
    const userToken = userDataObj.token;

    if (!editMode && !FormData.batchnumber) {
      FormData.batchnumber = generateCardNumber();
      setFormData((prev) => ({ ...prev, batchnumber: FormData.batchnumber }));
    }

    if (editMode) {
      try {
        const dobFormatted = FormData.dob
          ? (typeof FormData.dob === "object" && FormData.dob.format
              ? FormData.dob.format("YYYY-MM-DD")
              : FormData.dob)
          : "";
        const res = await updateMember(userToken, memberId, {
          ...FormData,
          dob: dobFormatted,
        });
        if (res.code == "200") {
          handleSnackbarOpen(res.message || "Member updated successfully", "success");
          navigate("/memberlist");
        } else {
          handleSnackbarOpen(res.message || "Update failed", "error");
        }
      } catch (error) {
        handleSnackbarOpen("Failed to update member", "error");
        console.error(error);
      }
      setSubmitted(false);
      return;
    }

    try {
      const res = await createNewMember(userToken, FormData);
      if (res.code == "200") {
        setidselect(res.data.member.id);
        handleSnackbarOpen(res.message, "success");
        setFormData({
          selectedFile: null,
          membership_number: "",
          photo: "",
          phone: "",
          name: "",
          alter_phone: "",
          address: "",
          email: "",
          dob: null,
          wedding_date: null,
          occupation: "",
          batchnumber:"",
          height: "",
          weight: "",
          sex: "",
          package: "",
          packagevalue: "",
          totalpaybleamount: "",
          discount: "",
          payableamount: "",
          modeofpayment: "",
          payingamount: "",
          activationdate: dayjs(),
          dateofpayment: dayjs(),
          identification_type: "",
          identification_id: "",
          membershipvalue:"",
          membership:"",
          membership_packagename:""
        });
      
          // Navigate to Member Details page for the new member
          navigate("/memberdetails", {
            state: { id: res.data.member.id, random_no: Math.random() },
          });
          setSubmitted(false);
      } else {
        handleSnackbarOpen(res.message, "error");
        setSubmitted(false);
        //   console.error(error); // Handle error
      }
    } catch (error) {
      console.error(error); // Handle error
    }
  };

  const clearForm = () => {
    setFormData({
      selectedFile: null,
      membership_number: "",
      photo: "",
      phone: "",
      name: "",
      alter_phone: "",
      address: "",
      email: "",
      dob: null,
      wedding_date: null,
      occupation: "",
      height: "",
      weight: "",
      sex: "",
      package: "",
      packagevalue: "",
      totalpaybleamount: "",
      discount: "",
      payableamount: "",
      modeofpayment: "",
      payingamount: "",
      activationdate: dayjs(),
      dateofpayment:  dayjs(),
      identification_type: "",
      identification_id: "",
      membershipvalue:"",
      membership:"",
      membership_packagename:""
    });
  };
  
  const handlePayingAmountChange = (e) => {
    // Allow only numbers (no decimals or symbols)
    const value = e.target.value.replace(/[^0-9]/g, ''); // Remove any non-numeric characters
  
    // Check if the value is greater than the payable amount
    if (parseFloat(value) > parseFloat(FormData.payableamount)) {
      return; // Prevent updating if the value exceeds the payable amount
    }
  
    setFormData({ ...FormData, payingamount: value }); // Update the state with sanitized value
  };
  
  const fetchData = async () => {
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const res = await AutoMembershipNumber(userToken, userId);

      if (res.code == "200") {
        setFormData((prev) => ({ ...prev, membership_number: res.data }));
      } else {
        // handleSnackbarOpen(res.message, 'error');
        console.error(error);
      }
    } catch (error) {
      console.error(error);
      // Handle errors
    }
  };
  const fetchDropdowndata = async () => {
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const res = await PackageDropdown(userToken, userId);

      if (res.code == "200") {
        setDropdowndata(res.data);
      } else {
        // handleSnackbarOpen(res.message, 'error');
        console.error(error);
      }
    } catch (error) {
      console.error(error);
      // Handle errors
    }
  };

  const fetchDropdownAdmissiondata = async () => {
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const res = await PackageadmissionDropdown(userToken, userId);

      if (res.code == "200") {
        setDropdownadmissiondata(res.data);
      } else {
        // handleSnackbarOpen(res.message, 'error');
        console.error(error);
      }
    } catch (error) {
      console.error(error);
      // Handle errors
    }
  };
  useEffect(() => {
    fetchDropdowndata();
    fetchDropdownAdmissiondata();
    if (!editMode) {
      fetchData(); // auto-generate membership number only for new members
      setFormData((prev) => ({ ...prev, batchnumber: generateCardNumber() }));
    }
  }, []);

  const handlepayblevalueChange = async (e) => {
    // Update state with the selected package
    const selectedPackageId = e.target.value;
    const selectedPackage = Dropdowndata.find(
      (row) => row.id === selectedPackageId
    );
    console.log(selectedPackage);
    setFormData({
      ...FormData,
      package: selectedPackageId,
      packagename: selectedPackage?.name || "",
    });

    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const res = await PackageDropdownvalue(
        userToken,
        userId,
        selectedPackageId
      );

      if (res.code == "200") {
        // Extract the package_amount from the first object in the array
        const packageAmount = res.data;
       
        setFormData((prevState) => ({
          ...prevState,
          packagevalue: packageAmount,
        }));
       
       
      } else {
        // handleSnackbarOpen(res.message, 'error');
        console.error(error);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle error if necessary
    }
  };
  const handlepayblevalueadmissionChange = async (e) => {
    // Update state with the selected package
    const selectedPackageId = e.target.value;
    const selectedPackage = Dropdownadmissiondata.find(
      (row) => row.id === selectedPackageId
    );
    console.log(selectedPackage);
    setFormData({
      ...FormData,
      membership: selectedPackageId,
      membership_packagename: selectedPackage?.name || "",
    });

    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const res = await PackageAdmissionDropdownvalue(
        userToken,
        userId,
        selectedPackageId
      );

      if (res.code == "200") {
        // Extract the package_amount from the first object in the array
        const packageAmount = res.data;
        // const total_payble_amount = res.data.total_payble_amount;
        setFormData((prevState) => {
          const totalpaybleamount =
            parseFloat(prevState.packagevalue || 0) + parseFloat(packageAmount || 0);
          
          return {
            ...prevState,
            membershipvalue: packageAmount,
            totalpaybleamount: totalpaybleamount,
          };
        });

        setpackageamount(totalpaybleamount);
      } else {
        // handleSnackbarOpen(res.message, 'error');
        console.error(error);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle error if necessary
    }
  };

  const handleTotalPayableAmountChange = (e) => {
    const enteredValue = e.target.value;

    // If entered value is greater than the package amount, set it to the package amount
    const totalPayableAmount =
      enteredValue > packageamount ? packageamount : enteredValue;

    // Update state with the total payable amount
    setFormData({ ...FormData, totalpaybleamount: totalPayableAmount });
  };

  // Function to generate the helper text
  const generateHelperText = () => {
    return FormData.totalpaybleamount < packageamount
      ? "Total payable amount cannot exceed the package value"
      : "";
  };

  const aadhaarRegex = /^[2-9]{1}[0-9]{11}$/;
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

  const handleIdentificationChange = (e) => {
    let value = e.target.value;
  
    // Handle Aadhaar (only numbers, 12 digits max)
    if (FormData.identification_type === "aadhaar") {
      // Allow only numbers, and limit to 12 digits
      value = value.replace(/[^0-9]/g, "").slice(0, 12); // Remove non-numeric characters and limit length to 12
    }
  
    // Handle PAN (allow uppercase letters and digits, 10 characters max)
    else if (FormData.identification_type === "pan") {
      // Convert to uppercase and allow only letters and numbers
      value = value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 10); // Allow valid PAN format and limit to 10 characters
    }
  
    // Set the value in the state
    setFormData({ ...FormData, identification_id: value });
  };
  
  const isAadhaarValid = aadhaarRegex.test(FormData.identification_id);
  const isPanValid = panRegex.test(FormData.identification_id);
  const isValid = (id, type) => {
    if (type === "aadhaar") {
      // Validate Aadhaar ID (only 12 digits, numeric)
      return /^[2-9]{1}[0-9]{11}$/.test(id); // Aadhaar ID: 12 digits, starting from 2-9
    }
    if (type === "pan") {
      // Validate PAN (A5-9, 4 Digits, A1 letter)
      return /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(id); // PAN format
    }
    return true; // For any other ID types (not applicable here)
  };
  
  // Function to calculate payable amount

  const handleDiscountChange = (e) => {
    let discount = e.target.value;
    discount = discount.replace(/[^0-9.]/g, '');
    setFormData({
      ...FormData,
      discount: discount,
      payableamount: calculatePayableAmount(
        FormData.totalpaybleamount,
        discount
      ), // Calculate the payable amount
    });
  };

  // Function to calculate payable amount without using floats
  const calculatePayableAmount = (totalAmount, discount) => {
    const total = totalAmount ? Number(totalAmount) : 0;
    const discountValue = discount ? Number(discount) : 0;
    return (total - discountValue).toString(); // Subtract values and return as string
  };

  // Generate helper text based on validation logic
  const generateHelperTextDIS = () => {
    return FormData.totalpaybleamount > 0 &&
      FormData.discount > FormData.totalpaybleamount
      ? "Discount cannot be greater than total amount"
      : "";
  };

  const handleEmailChange = (e) => {
    const value = e.target.value.toLowerCase(); // Convert email to lowercase
    setFormData({ ...FormData, email: value });
  };

  const isValidEmail = (email) => {
    // Regular expression to validate email format
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return emailRegex.test(email);
  };
  return (
    <Box
      sx={{ display: "flex", backgroundColor: "#EFEDF1", minHeight: "100vh" }}
    >
      <Header />
      <CssBaseline />
      <Box
        component="main"
        sx={{ flexGrow: 1, overflowY: "auto", padding: "20px" }}
      >
        <div style={{ display: "flex", flexGrow: 1, marginTop: "50px" }}>
          <div style={{ flex: 1, marginTop: "15px" }}>
            <Box sx={{ mb: 2 }}>
              <Box
                  sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  background: "#ffffff",
                  padding: "16px 24px",
                  borderRadius: "16px",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                  border: "1px solid rgba(0, 0, 0, 0.1)",
                }}
                >
                <Typography 
                  variant="h6" 
                  sx={{ 
                    fontWeight: "bold",
                    color: appColors.evergreen,
                    fontSize: "1.25rem",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      width: "4px",
                      height: "24px",
                      background: `linear-gradient(to bottom, ${appColors.evergreen}, ${appColors.leaf})`,
                      borderRadius: "2px",
                      marginRight: "12px"
                    }}
                  />
                  {editMode ? "Edit Member" : "New Member Registration"}
                </Typography>

              <Button
                variant="contained"
                  onClick={() => navigate("/memberlist")}
                sx={{
                    background: `linear-gradient(135deg, ${appColors.evergreen} 0%, ${appColors.leaf} 100%)`,
                    color: "#fff",
                  textTransform: "none",
                    fontWeight: "600",
                    padding: "8px 24px",
                    borderRadius: "8px",
                    boxShadow: "0 4px 12px rgba(26, 35, 126, 0.15)",
                    '&:hover': {
                      background: `linear-gradient(135deg, ${appColors.leaf} 0%, ${appColors.evergreen} 100%)`,
                      boxShadow: "0 6px 16px rgba(26, 35, 126, 0.2)",
                      transform: "translateY(-1px)",
                    },
                  }}
              >
                  <Box component="span" sx={{ mr: 1 }}>←</Box>
                View List
              </Button>
              </Box>
            </Box>
            <Card sx={{ marginTop: "10px", marginBottom: "10px" }}>
              <Box sx={{ marginTop: "10px", marginBottom: "10px" }}>
                <Grid
                  container
                  spacing={3}
                  sx={{
                    marginTop: "20px",
                    marginBottom: "20px",
                    paddingX: "20px",
                  }}
                >
                  {/* First Row */}
                  <Grid   size={{ xs: 4}}>
                    {/* Photo upload / preview */}
                    {FormData.photo ? (
                      <div style={{ border: `2px solid ${appColors.leaf}`, borderRadius: "10px", height: "160px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", overflow: "hidden", position: "relative" }}>
                        <img src={FormData.photo} alt="Member Photo" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                        <div style={{ position: "absolute", bottom: 0, width: "100%", display: "flex", background: "rgba(0,0,0,0.5)" }}>
                          <label style={{ flex: 1, textAlign: "center", color: "#fff", fontSize: "12px", padding: "6px 0", cursor: "pointer", borderRight: "1px solid rgba(255,255,255,0.2)" }}>
                            <u>Upload</u>
                            <input accept="image/*" type="file" onChange={handleFileChange} style={{ display: "none" }} />
                          </label>
                          <button onClick={openWebcam} style={{ flex: 1, background: "none", border: "none", color: "#fff", fontSize: "12px", padding: "6px 0", cursor: "pointer" }}>
                            📷 Camera
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div onDragOver={handleDragOver} onDrop={handleDrop} style={{ border: "2px dashed #C8E6C9", borderRadius: "10px", height: "160px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px", backgroundColor: "#F6F5F0" }}>
                        <CameraAltIcon sx={{ fontSize: 32, color: appColors.leaf, opacity: 0.7 }} />
                        <div style={{ display: "flex", gap: "8px" }}>
                          <label style={{ cursor: "pointer" }}>
                            <Button variant="outlined" size="small" component="span" sx={{ textTransform: "none", borderColor: appColors.leaf, color: appColors.leaf, fontSize: "0.78rem", '&:hover': { borderColor: appColors.evergreen, backgroundColor: appColors.leafSoft } }}>
                              Upload File
                            </Button>
                            <input accept="image/*" type="file" onChange={handleFileChange} style={{ display: "none" }} />
                          </label>
                          <Button variant="contained" size="small" onClick={openWebcam} startIcon={<CameraAltIcon sx={{ fontSize: '1rem' }} />} sx={{ textTransform: "none", backgroundColor: appColors.leaf, fontSize: "0.78rem", '&:hover': { backgroundColor: appColors.evergreen } }}>
                            Use Camera
                          </Button>
                        </div>
                        <Typography sx={{ fontSize: "0.72rem", color: "#5B6660" }}>or drag and drop an image here</Typography>
                      </div>
                    )}

                    {/* Webcam Dialog */}
                    <Dialog open={webcamOpen} onClose={closeWebcam} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: '16px', overflow: 'hidden' } }}>
                      <DialogTitle sx={{ background: `linear-gradient(135deg, ${appColors.evergreen}, ${appColors.leaf})`, color: '#fff', py: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <CameraAltIcon fontSize="small" /> Take Photo
                        </span>
                        <IconButton size="small" onClick={flipCamera} sx={{ color: '#fff' }} title="Flip camera">
                          <FlipCameraAndroidIcon />
                        </IconButton>
                      </DialogTitle>
                      <DialogContent sx={{ p: 0, background: '#000', position: 'relative' }}>
                        <video ref={videoRef} autoPlay playsInline style={{ width: '100%', display: 'block', maxHeight: '400px', objectFit: 'cover' }} />
                        <canvas ref={canvasRef} style={{ display: 'none' }} />
                      </DialogContent>
                      <DialogActions sx={{ background: appColors.evergreen, justifyContent: 'space-between', px: 2, py: 1.5 }}>
                        <Button onClick={closeWebcam} sx={{ color: 'rgba(255,255,255,0.7)', textTransform: 'none' }}>Cancel</Button>
                        <Button onClick={capturePhoto} variant="contained" startIcon={<RadioButtonCheckedIcon />} sx={{ backgroundColor: '#C0392B', textTransform: 'none', fontWeight: 600, borderRadius: '10px', px: 3, '&:hover': { backgroundColor: '#a93226' } }}>
                          Capture
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </Grid>
                  {/* Second Row */}
                  <Grid size={{ xs: 4}}>
                    <Grid container spacing={3}>
                      <Grid size={{ xs: 12}}>
                        <TextField
                          label="Enter Membership No..."
                          inputProps={{ readOnly: true }}
                          fullWidth
                          value={FormData.membership_number}
                          onChange={(e) =>
                            setFormData({
                              ...FormData,
                              membership_number: e.target.value,
                            })
                          }
                          error={submitted && !FormData.membership_number}
                          helperText={
                            submitted &&
                            !FormData.membership_number &&
                            "Membership No is required"
                          }
                        />
                      </Grid>
                      <Grid   size={{ xs: 12}}>
                        <TextField
                          label="Enter Name..."
                          fullWidth
                          value={FormData.name}
                          onChange={(e) =>
                            setFormData({ ...FormData, name: e.target.value.toUpperCase() })
                          }
                          error={submitted && !FormData.name}
                          helperText={
                            submitted && !FormData.name && "Name  is required"
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid   size={{ xs: 4}}>
                    <Grid container spacing={3}>
                      <Grid size={{ xs: 12}}>
                        {/* Adjusted text field to match the height */}
                        <TextField
                          label="Enter Phone..."
                          fullWidth
                          multiline
                          variant="outlined"
                          value={FormData.phone}
                          onChange={(e) =>
                            setFormData({ ...FormData, phone: e.target.value })
                          } // Display helper text if the field is empty
                          error={submitted && !FormData.phone}
                          helperText={
                            submitted &&
                            !FormData.phone &&
                            "phone No is required"
                          }
                        />
                      </Grid>
                      <Grid size={{ xs: 12}}>
                        <TextField
                          label="Alternate Phone"
                          fullWidth
                          value={FormData.alter_phone}
                          onChange={(e) =>
                            setFormData({
                              ...FormData,
                              alter_phone: e.target.value,
                            })
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid size={{ xs: 4}}>
                    {/* Combined text field */}

                    {/* Adjusted text field to match the height */}
                    <TextField
                      label="Permanent address"
                      multiline
                      rows={4}
                      fullWidth
                      variant="outlined"
                      value={FormData.address}
                      onChange={(e) =>
                        setFormData({ ...FormData, address: e.target.value.toUpperCase() })
                      }
                      error={submitted && !FormData.address}
                      helperText={
                        submitted && !FormData.address && "Address  is required"
                      }
                    />

                    <FormControl sx={{ marginTop: "35px" }} fullWidth>
                      <InputLabel id="sex-label">
                        Identification Type
                      </InputLabel>
                      <Select
                        labelId="sex-label"
                        label="Identification Type"
                        id="identification_type"
                        value={FormData.identification_type}
                        onChange={(e) =>
                          setFormData({
                            ...FormData,
                            identification_type: e.target.value,
                          })
                        }
                        fullWidth
                        // error={submitted && !FormData.identification_type}
                      >
                        <MenuItem value="aadhaar">Aadhaar</MenuItem>
                        <MenuItem value="pan">Pan No</MenuItem>
                      </Select>
                      {/* {submitted && !FormData.identification_type && (
                        <FormHelperText error>
                          Identification Type is required
                        </FormHelperText>
                      )} */}
                    </FormControl>
                  </Grid>

                  <Grid size={{ xs: 8}}>
                    <Grid container spacing={3}>
                      <Grid size={{ xs: 12}}>
                      <TextField
      label="Email"
      fullWidth
      value={FormData.email}
      onChange={handleEmailChange} // Convert to lowercase on input
      error={(!FormData.email || !isValidEmail(FormData.email))}
      helperText={
        submitted &&
        (!FormData.email
          ? "Email is required"
          : !isValidEmail(FormData.email)
          ? "Invalid email format"
          : "")
      }
    />
                      </Grid>
                      <Grid size={{ xs: 12}}>
                        <Grid size={{ xs: 12}}>
                          {/* Adjusted text field to match the height */}
                          <React.Fragment>
                            <Box>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoItem components={["DatePicker"]}>
                                  <DatePicker
                                    value={FormData.dob}
                                    onChange={(date) =>
                                      setFormData({ ...FormData, dob: date })
                                    } // Update 'dob' state in formData
                                    label="Dob"
                                    format="DD/MM/YYYY"
                                    clearable
                                    slotProps={{
                                      textField: {
                                        error: submitted && !FormData.dob,
                                        helperText:
                                          submitted &&
                                          !FormData.dob &&
                                          "Dob is required",
                                      },
                                    }}
                                  />
                                </DemoItem>
                              </LocalizationProvider>
                            </Box>
                          </React.Fragment>
                        </Grid>
                      </Grid>
                      {editMode ? (
                        <Grid container spacing={2} size={{ xs: 12 }}>
                          <Grid size={{ xs: 6 }}>
                            <TextField
                              label="Identification Id"
                              fullWidth
                              variant="outlined"
                              value={FormData.identification_id}
                              onChange={handleIdentificationChange}
                            />
                          </Grid>
                          <Grid size={{ xs: 6 }}>
                            <TextField
                              name="batchnumber"
                              type="number"
                              label="Card Number"
                              fullWidth
                              placeholder="Enter Card Number..."
                              value={FormData.batchnumber}
                              onChange={(e) => setFormData({ ...FormData, batchnumber: e.target.value.replace(/[^0-9]/g, '') })}
                            />
                          </Grid>
                        </Grid>
                      ) : (
                        <Grid size={{ xs: 12}}>
                          <React.Fragment>
                            <Box>
                              <TextField
                                label="Identification Id"
                                fullWidth
                                variant="outlined"
                                value={FormData.identification_id}
                                onChange={handleIdentificationChange}
                              />
                            </Box>
                          </React.Fragment>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
              <hr style={{ borderTop: "2px solid #ccc" }} />
              <Typography sx={{ marginLeft: "10px" }} variant="h6">
                Body/Health
              </Typography>
              <Box sx={{ marginTop: "10px", marginBottom: "10px" }}>
                <Grid
                  container
                  spacing={3}
                  sx={{ marginBottom: "10px", paddingX: "10px" }}
                >
                  <Grid  size={{ xs: 4}}>
                    <Grid  size={{ xs: 12}}>
                    
                       <FormControl variant="outlined" sx={{ width: '335px' }}>
  <OutlinedInput
    id="outlined-adornment-Height"
    placeholder=" Enter Height"
    value={FormData.height}
    endAdornment={<InputAdornment position="end">feet</InputAdornment>}
    aria-describedby="outlined-Height-helper-text"
    onChange={(e) => setFormData({ ...FormData, height: e.target.value })}
    inputProps={{
      'aria-label': 'weight',
    }}
  />
</FormControl>
                    </Grid>
                  </Grid>
                  {/* Second Row */}
                  <Grid size={{ xs: 4}}>
                    <Grid container spacing={3}>
                      <Grid  size={{ xs: 12}}>
                      
                      <FormControl variant="outlined" sx={{ width: '335px' }}>
  <OutlinedInput
    id="outlined-adornment-weight"
    placeholder="Enter Weight"
    value={FormData.weight}
    endAdornment={<InputAdornment position="end">kg</InputAdornment>}
    aria-describedby="outlined-weight-helper-text"
    onChange={(e) => setFormData({ ...FormData, weight: e.target.value })}
    inputProps={{
      'aria-label': 'weight',
    }}
  />
</FormControl>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid  size={{ xs: 4}}> 
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12}}>
                        <FormControl fullWidth>
                          <InputLabel id="sex-label">Sex</InputLabel>
                          <Select
                            labelId="sex-label"
                            label="sex"
                            id="sex"
                            value={FormData.sex}
                            onChange={(e) =>
                              setFormData({ ...FormData, sex: e.target.value })
                            } // Update 'sex' state in formData
                            placeholder="Select Sex..."
                            fullWidth
                            error={submitted && !FormData.sex}
                            helperText={
                              submitted && !FormData.sex && "sex  is required"
                            }
                          >
                            <MenuItem value="male">Male</MenuItem>
                            <MenuItem value="female">Female</MenuItem>
                            <MenuItem value="transgender">Transgender</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
              {!editMode && <hr style={{ borderTop: "2px solid #ccc" }} />}
              {!editMode && (
                <Typography sx={{ marginLeft: "10px" }} variant="h6">
                  Payment
                </Typography>
              )}
              <Box sx={{ marginTop: "10px", marginBottom: "10px" }}>
              {!editMode && (
                <>
                <Grid
                  container
                  spacing={3}
                  sx={{ marginBottom: "10px", paddingX: "10px" }}
                >
                  <Grid  size={{ xs: 4}}>
                    <Grid  size={{ xs: 12}}>
                      <FormControl fullWidth>
                        <InputLabel id="package-label"> Package</InputLabel>
                        <Select
                          labelId="package-label"
                          id="package"
                          label="Package"
                          value={FormData.package}
                          onChange={handlepayblevalueChange}
                          placeholder="choose your Package..."
                          fullWidth
                        >
                          {Dropdowndata.map((row) => (
                            <MenuItem value={row.id}>{row.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                  {/* Second Row */}
                  <Grid  size={{ xs: 4}}>
                    <Grid container spacing={3}>
                      <Grid  size={{ xs: 12}}>
                        <TextField
                          label="Package Value"
                          inputProps={{ readOnly: true }}
                          fullWidth
                          placeholder="Package Value"
                          value={FormData.packagevalue}
                          onChange={(e) =>
                            setFormData({
                              ...FormData,
                              packagevalue: e.target.value,
                            })
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid  size={{ xs: 4}}>
      <Grid container spacing={2}>
        <Grid  size={{ xs: 12}}>
          <FormControl fullWidth>
            <InputLabel id="membership-label">Membership</InputLabel>
            <Select
              labelId="membership-label"
              id="membership"
              label="Membership"
              value={FormData.membership}
              onChange={handlepayblevalueadmissionChange}
              placeholder="Choose Membership"
              fullWidth
            >
              {/* Replace with actual membership options */}
              {Dropdownadmissiondata.map((row) => (
                            <MenuItem value={row.id}>{row.name}</MenuItem>
                          ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Grid>

    <Grid size={{ xs: 4}}>
      <Grid container spacing={3}>
        <Grid  size={{ xs: 12}}>
          <TextField
            label="Membership Value"
            inputProps={{ readOnly: true }}
            fullWidth
            placeholder="Membership Value"
            value={FormData.membershipvalue}
            onChange={(e) =>
              setFormData({
                ...FormData,
                membershipvalue: e.target.value,
              })
            }
          />
        </Grid>
      </Grid>
    </Grid>

                  <Grid size={{ xs: 4}}>
                    <Grid container spacing={3}>
                      <Grid  size={{ xs: 12}}>
                        <TextField
                         inputProps={{ readOnly: true }}
                          label="Total payable Amount"
                          fullWidth
                          placeholder="Total payable Amount"
                          value={FormData.totalpaybleamount}
                          onChange={handleTotalPayableAmountChange}
                          helperText={generateHelperText()}
                          error={FormData.totalpaybleamount < packageamount}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid  size={{ xs: 4}}>
                    <Grid  size={{ xs: 12}}>
                      <TextField
                        label="Discount / Offer"
                        fullWidth
                        placeholder="Discount / Offer"
                        value={FormData.discount}
                        onChange={handleDiscountChange}
                        helperText={generateHelperTextDIS()}
                        error={
                          parseFloat(FormData.discount) >
                          parseFloat(FormData.totalpaybleamount)
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={2}
                  sx={{
                    marginTop: "20px",
                    marginBottom: "20px",
                    paddingX: "10px",
                  }}
                >
            
                  {/* Second Row */}
                  <Grid  size={{ xs: 4}}>
                    <Grid container spacing={2}>
                      <Grid  size={{ xs: 12}}>
                        <TextField
                          disabled
                          label="Payable Amount"
                          fullWidth
                          value={FormData.payableamount}
                          onChange={(e) =>
                            setFormData({
                              ...FormData,
                              payableamount: e.target.value,
                            })
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid  size={{ xs: 4}}>
                    <Grid container spacing={3}>
                      <Grid  size={{ xs: 12}}>
                        <TextField
                          label="Paying Amount"
                          fullWidth
                          placeholder=" Paying Amount"
                          value={FormData.payingamount}
                          onChange={handlePayingAmountChange}
                          helperText={
                            submitted && FormData.payingamount === ''
                              ? 'Amount is required'
                              : ''
                          }
                          error={submitted && FormData.payingamount === ''} // Error if empty after submit
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid  size={{ xs: 4}}>
                    <Grid  size={{ xs: 12}}>
                      <FormControl fullWidth>
                        <InputLabel id="payment-mode-label">
                          Mode Of Payment
                        </InputLabel>
                        <Select
                          label="Mode Of Payment"
                          labelId="payment-mode-label"
                          id="payment-mode"
                          value={FormData.modeofpayment}
                          onChange={(e) =>
                            setFormData({
                              ...FormData,
                              modeofpayment: e.target.value,
                            })
                          }
                          fullWidth
                        >
                          <MenuItem value="paytm">Paytm</MenuItem>
                          <MenuItem value="googlepay">Google Pay</MenuItem>
                          <MenuItem value="phonepe">PhonePe</MenuItem>
                          <MenuItem value="cash">Cash</MenuItem>
                          <MenuItem value="card"> Card</MenuItem>
                          {/* Add more payment options as needed */}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={2}
                  sx={{
                    marginTop: "20px",
                    marginBottom: "20px",
                    paddingX: "10px",
                  }}
                >
            
                  {/* Second Row */}
                  <Grid  size={{ xs: 4}}>
                    <Grid container spacing={3}>
                      <Grid  size={{ xs: 12}}>
                        <React.Fragment>
                          <Box>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoItem components={["DatePicker"]}>
                                <DatePicker
                                  value={FormData.dateofpayment}
                                  onChange={(date) =>
                                    setFormData({
                                      ...FormData,
                                      dateofpayment: date,
                                    })
                                  } // Update 'dob' state in formData
                                  label="Date of Payment"
                                  format="DD/MM/YYYY"
                                  views={['year', 'month', 'day']}
                                  clearable
                                  slotProps={{
                                    textField: {
                                      error:
                                        submitted && !FormData.dateofpayment,
                                      helperText:
                                        submitted &&
                                        !FormData.dateofpayment &&
                                        "Date of Payment is required",
                                    },
                                  }}
                                />
                              </DemoItem>
                            </LocalizationProvider>
                          </Box>
                        </React.Fragment>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid  size={{ xs: 4}}>
                    <Grid container spacing={2}>
                      <Grid  size={{ xs: 12}}>
                        <React.Fragment>
                          <Box>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoItem components={["DatePicker"]}>
                                <DatePicker
                                  value={FormData.activationdate}
                                  onChange={(date) =>
                                    setFormData({
                                      ...FormData,
                                      activationdate: date,
                                    })
                                  } // Update 'dob' state in formData
                                  label="Activation Date"
                                  format="DD/MM/YYYY"
                                  views={['year', 'month', 'day']}
                                  clearable
                                  slotProps={{
                                    textField: {
                                      error:
                                        submitted && !FormData.activationdate,
                                      helperText:
                                        submitted &&
                                        !FormData.activationdate &&
                                        "Activation Date is required",
                                    },
                                  }}
                                />
                              </DemoItem>
                            </LocalizationProvider>
                          </Box>
                        </React.Fragment>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid size={{ xs: 4 }}>
                    <TextField
                      name="batchnumber"
                      type="number"
                      label="Card Number"
                      fullWidth
                      placeholder="Enter Card Number..."
                      value={FormData.batchnumber}
                      onChange={(e) => setFormData({ ...FormData, batchnumber: e.target.value.replace(/[^0-9]/g, '') })}
                    />
                  </Grid>
                </Grid>
                </>
              )}

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    margin: "15px",
                    justifyContent: "space-between",
                    gap: "16px"
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={clearForm}
                    sx={{
                      textTransform: "none",
                      padding: "10px 32px",
                      borderRadius: "8px",
                      fontWeight: 600,
                      fontSize: "0.95rem",
                      color: appColors.evergreen,
                      borderColor: appColors.evergreen,
                      backgroundColor: "white",
                      boxShadow: "0 2px 8px rgba(26, 35, 126, 0.15)",
                      '&:hover': {
                        borderColor: appColors.leaf,
                        backgroundColor: "rgba(26, 35, 126, 0.04)",
                        boxShadow: "0 4px 12px rgba(26, 35, 126, 0.2)",
                      },
                      minWidth: "120px"
                    }}
                  >
                    Clear Form
                  </Button>
                  <Button
                    onClick={triggerSave}
                    variant="contained"
                    sx={{
                      textTransform: "none",
                      padding: "10px 32px",
                      borderRadius: "8px",
                      fontWeight: 600,
                      fontSize: "0.95rem",
                      background: `linear-gradient(135deg, ${appColors.evergreen} 0%, ${appColors.leaf} 100%)`,
                      color: "white",
                      boxShadow: "0 4px 12px rgba(26, 35, 126, 0.25)",
                      '&:hover': {
                        background: `linear-gradient(135deg, ${appColors.leaf} 0%, ${appColors.evergreen} 100%)`,
                        boxShadow: "0 6px 16px rgba(26, 35, 126, 0.3)",
                        transform: "translateY(-1px)",
                      },
                      minWidth: "120px"
                    }}
                  >
                    {editMode ? "Update Member" : "Process Payment"}
                  </Button>
                </Box>
              </Box>
            </Card>
          </div>
        </div>
      </Box>
      <Dialog open={openConfirmDialog} onClose={handleConfirmDialogClose}>
  <DialogTitle>{editMode ? "Confirm Update" : "Confirm Save"}</DialogTitle>
  <DialogContent>
    <DialogContentText>Are you sure you want to proceed?</DialogContentText>
  </DialogContent>
  <DialogActions>
    <Button  variant="outlined" onClick={handleConfirmDialogClose} color="secondary"   sx={{
                      textTransform: "none",
                      whiteSpace: "nowrap",
                      fontWeight: 700,
                    }}>
      Cancel
    </Button>
    <Button  variant="contained" onClick={handleConfirmSave}    sx={{
                      textTransform: "none",
                      whiteSpace: "nowrap",
                      fontWeight: 700,
                    }} color="primary" autoFocus>
      Confirm
    </Button>
  </DialogActions>
</Dialog>

      <AppToast open={openToast} message={snackbarMessage} severity={snackbarSeverity} onClose={handleToastClose} />
    </Box>
  );
}

export default MemberList;
